import React from "react";
import { useSpring, animated } from "@react-spring/web"; // web.cjs is required for IE 11 support
import styled from "styled-components/macro";

const SpringStyles = styled.div`
  width: fit-content;
`;

const AnimatedSpringStyles = animated(SpringStyles);

const SPRING_UP_DOWN_PX = 35;
// https://material-ui.com/components/modal/
export const SpringUpDown: any = React.forwardRef((props, ref) => {
  const {
    in: open,
    children,
    onEnter,
    onExited,
    isAnimationEnabled = true,
    style,
    ...other
  } = props as any;
  const springUpDown = useSpring({
    from: isAnimationEnabled
      ? {
          opacity: 0,
          transform: `translateY(${SPRING_UP_DOWN_PX}px)`,
        }
      : {},
    to: isAnimationEnabled
      ? {
          opacity: open ? 1 : 0,
          transform: `translateY(${open ? 0 : SPRING_UP_DOWN_PX}px)`,
        }
      : {},
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <AnimatedSpringStyles
      className="springUpDownWrapper"
      ref={ref}
      style={{
        ...springUpDown,
        pointerEvents: open ? "auto" : "none",
        ...style,
      }}
      {...other}
    >
      {children}
    </AnimatedSpringStyles>
  );
});
